export default __webpack_public_path__ + "static/media/cc-logo-white.40b6aa5d.svg";